import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { fetchAuthSession } from '@aws-amplify/auth';

const CallbackPage = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    // Handle the OAuth callback
    const handleCallback = async () => {
      try {
        // In Amplify v6, the redirect is automatically handled
        // We just need to check if the session exists
        const session = await fetchAuthSession();
        
        if (session && session.tokens) {
          console.log('Successfully authenticated');
          // Redirect to home page
          window.location.href = '/';
        } else {
          throw new Error('No valid session found');
        }
      } catch (error) {
        console.error('Error during authentication callback:', error);
        setError(error.message || 'Authentication failed');
        // Redirect to login page after short delay if there's an error
        setTimeout(() => {
          window.location.href = '/login';
        }, 3000);
      }
    };

    handleCallback();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        bgcolor: 'background.default'
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 3 }}>
        {error ? `Error: ${error}` : 'Completing sign in...'}
      </Typography>
    </Box>
  );
};

export default CallbackPage;
